import React, { useEffect, useRef, useState } from 'react'
import * as XLSX from 'xlsx';
// import { BASE_URL } from '../../../axios';
import { BASE_URL } from '../../../axios';
import { Modal } from 'react-bootstrap';

import axios from 'axios';

const OngoingProjectData = () => {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);



    const [fileName, setFileName] = useState("");
    const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});

    const [jsonData, setJsonData] = useState(null);


    const bulktableRef = useRef(null);
    const handleDownload = () => {
        const table = bulktableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Projects Sheet" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Project Data Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };


    const handleClose = () => {
        setFileName("")
        setExcelJson(null)
        setDocErrors({})
        setShow(false)
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setFileName(file.name);
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            // 👉 Get sheet name (dynamic)
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // 👉 Convert to JSON
            const json = XLSX.utils.sheet_to_json(worksheet, {
                defval: "", // avoid undefined values
            });

            console.log("Excel JSON:", json);
            setJsonData(json);
        };

        reader.readAsArrayBuffer(file);
    };


    const [loading, setLoading] = useState(false); //loading logic
    const handleSubmit = async () => {
        setLoading(true); //loading logic
        if (!jsonData) {
            alert("Please upload an Excel file first!");
            return;
        }
        try {
            const response = await axios.post(`${BASE_URL}/website/bulkcreateexcelprojects/`, jsonData);
            // alert('Attendance uploaded successfully!');

            handleClose()
        } catch (error) {
            console.error('Error uploading attendance:', error);

            // alert('Error uploading Slary Structures.');
        } finally {
            setLoading(false); //loading logic

        }
    };






    const [selectedIndex, setSelectedIndex] = useState(-1);

    const handleClick = (index) => {
        setSelectedIndex(index);
    };

    const tableRef = useRef(null);





    return (
        <>
            {/*********************************** Bulk Upload ***************************** */}
            {/* <button
                title="Bulk Upload Data"
                className="px-4 py-2 bg-blue-500 text-white rounded"
                onClick={handleShow} // This triggers handleShow to open the modal
                style={{ margin: "2px" }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                    <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                </svg>
            </button> */}


            <Modal show={show} onHide={handleClose}
                dialogClassName="request-leave  width-40vw"
            >
                <Modal.Header
                    className="task-Tab-heading font-weight500 font-size-heading "
                >
                    <Modal.Title>Upload Bulk Project Data in Format:</Modal.Title>

                    <button onClick={handleDownload} className="model-button-download model-button font-weight500" style={{ marginLeft: "35vw" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                            <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                            </g>
                        </svg>
                        {"  "} Format
                    </button>
                </Modal.Header>
                <Modal.Body>


                    <div className="table-css-white-background" style={{ display: "none" }}>
                        <table
                            ref={bulktableRef}
                            id="my-table"
                            style={{
                                borderColor: "#323232",
                                borderRadius: "5px",
                                padding: "0px 5px",
                                borderWidth: "1px",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th className="summary-excel-tab br-5"> project_name</th>
                                    <th className="summary-excel-tab br-5">project_short_name</th>
                                    <th className="summary-excel-tab br-5">state</th>
                                    <th className="summary-excel-tab br-5">period</th>
                                    <th className="summary-excel-tab br-5">cost</th>
                                    <th className="summary-excel-tab br-5"> project_length</th>
                                    <th className="summary-excel-tab br-5">client</th>
                                    <th className="summary-excel-tab br-5">consultancy_service</th>
                                </tr>
                            </thead>
                        </table>

                    </div>



                    <div className="flex-column field-cont-div">
                        <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
                            Upload File
                        </label>
                        <label
                            htmlFor="document_file"
                            className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                                }`}
                        >
                            <svg
                                className="pdf-input"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </label>
                        <input
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                            id="document_file"
                            name="document_file"
                            className="file-inputs align-center"
                            style={{ display: "none", position: "relative" }} />
                        {fileName && <p className="file-name align-center">{fileName}</p>}
                        <br />
                        {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
                    </div>

                    <div className="button-models">
                        <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="model-button-download model-button font-weight500" onClick={handleSubmit} disabled={loading}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                                </g>
                            </svg>
                            {"  "} {loading ? "Uploading..." : "Upload"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};





const OngoingProject = ({ status }) => {
    const [ongoingData, setOngoingData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Function to fetch data from the API
    const getOngoingData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/website/excellproject/`);
            let filterdata = res.data.filter((a) => status === "completed" ? a.status === status || a.status === "Terminate" : a.status !== "completed" && a.status !== "Terminate");
            setOngoingData(filterdata); // Store API data
        } catch (err) {
            console.error("Error fetching ongoing data:", err);
            setError('Failed to load data from API');
        } finally {
            setLoading(false);
        }
    };

    console.log(status);


    // Fetch data when the component mounts (this only runs once)
    useEffect(() => {
        getOngoingData(); // Fetch the ongoing data from API
    }, []);

    return (
        <div className='mb-20'>
            <h2 className="text-center mb-10 mt-20 text-4xl font-bold ">Project Data</h2>

            <div className="text-center my-4">
                <OngoingProjectData />
            </div>

            {/* Scrollable container */}
            <div className="overflow-x-auto max-h-[500px] text-justify relative max-w-[100vw] mx-auto">
                <table className="table-auto border-collapse w-full">
                    <thead className="sticky top-0 bg-[#213140] text-white text-center z-10">
                        <tr className="custom-table-head-td">
                            <th className="px-2 py-2">S.No.</th>
                            <th className="px-2 py-2">Project Code</th>
                            <th className="px-2 py-2">Status</th>
                            <th className="px-2 py-2">Project Section</th>
                            <th className="px-2 py-2">Description of Services</th>
                            <th className="px-2 py-2">Lane</th>
                            <th className="px-2 py-2">State</th>
                            <th className="px-2 py-2">Project Length</th>
                            <th className="px-2 py-2">Mode</th>
                            <th className="px-2 py-2">Authority</th>
                            {/* <th className="px-2 py-2">Completion Certificate</th> */}
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-300">
                        {ongoingData?.map((i, index) => (
                            <tr key={index} className="hover:bg-gray-100 transition">
                                <td className="px-2 py-2 text-center">{index + 1}</td>
                                <td className="px-2 py-2">{i.project_code}</td>
                                <td className="px-2 py-2 text-center">
                                    {i?.status === "completed" ? "closed" : i.status
                                        // ?.toLowerCase()
                                        // .replace(/(^\w|[_\s]+(.)?)/g, (_, c, d) =>
                                        //     d ? d.toUpperCase() : c.toUpperCase()
                                        // )
                                    }
                                </td>
                                <td className="px-2 py-2 text-center">
                                    {i.project_section
                                        // ?.toLowerCase()
                                        // .replace(/(^\w|[_\s]+(.)?)/g, (_, c, d) =>
                                        //     d ? d.toUpperCase() : c.toUpperCase()
                                        // )
                                    }
                                </td>
                                <td className="px-2 py-2 text-center" title={i.description}>
                                    {i.description?.slice(0, 10) + "..."}
                                </td>
                                <td className="px-2 py-2 text-center">{i.lane}</td>
                                <td className="px-2 py-2 text-center">{i.state}</td>
                                <td className="px-2 py-2 text-center">{i.project_length}</td>
                                <td className="px-2 py-2 text-center">{i.mode}</td>
                                <td className="px-2 py-2 text-center">{i.authority_client}</td>
                                {/* <td className="px-2 py-2 text-center">
                                    {i.completion_certificate === null ? (
                                        "--"
                                    ) : (
                                        <a
                                            href={i.completion_certificate?.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 underline"
                                        >
                                            {i.completion_certificate?.text}
                                        </a>
                                    )}
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>

    );
};



export default OngoingProject;


